<!--
 * @Author: lijiahui
 * @Date: 2020-06-02 15:31:03
 * @LastEditTime: 2022-08-02 11:14:26
 * @LastEditors: xuhuining
 * @Description: 所有评论
 * @FilePath: \xingmahui_front\src\components\comment\allComment.vue
-->
<template>
  <div v-if="articalId" class="wrap">
    <div class="commentWrap">
      <!-- 标题 -->
      <div class="title">
        <span class="num">评论区<span v-if="!commentTotal == 0">({{ commentTotal }})</span></span>
        <p class="sort_box">
          <span :class="{ 'active': hotOrNew == 0 }"
                @click="getAllComment(0, true),$emit('sensorsFn', '最热')">最热</span>
          <i></i>
          <span :class="{ 'active': hotOrNew == 1 }"
                @click="getAllComment(1, true),$emit('sensorsFn', '最新')">最新</span>
        </p>
      </div>
      <div>
        <span v-lazy:background-image="getCookie('xmh_headimgurl')" class="gravatar"></span>
        <van-search ref="search" class="speak" left-icon="" placeholder="说点什么吧" shape="round"
                    @click="isFocusFun('1')"/>
      </div>
      <!-- 无评论的提示 -->
      <div v-if="commentTotal === 0" class="backbone">
        <van-image :src="require('../../assets/images/baby/backbone.png')"/>
        <div>
          这里静悄悄，点击说点什么<span @click="isFocusFun('2')">点击评论</span>
        </div>
      </div>
      <!-- 评论列表 -->
      <van-list v-model="listLoading"
                :error.sync="listError"
                :finished="listFinished"
                class="vanlist"
                error-text="请求失败，点击重新加载"
                @load="getAllComment(0)">
        <div v-for="(comment, index) in (!upComShow ? commentAllList.slice(0, 3) : commentAllList)" :key="comment.id"
             class="commentList">

          <div class="reply-comment-item">
            <span v-lazy:background-image="comment.headImgUrl" class="commentAvatars"></span>
            <div class="comment-content">
              <span class="commentName">
                {{ comment.userName }}
                <span v-if="comment.isAuthor == 1" class="myComment">作者</span>
              </span>
              <div ref="commentList" class="commentText" @click="replyComment(comment, '1')">
                <div v-longpress="(userInfo && userInfo.crm_id == comment.crmId) ? dialogToast : ''"
                     :data-param="JSON.stringify(comment)"
                     class="con"
                     v-text="comment.content"></div>
              </div>
              <p class="bottom">
                <span class="time">
                  {{ comment.createTime }}
                  <span class="reply_btn" @click="replyComment(comment, '1')">
                    回复
                  </span>
                </span>
              </p>
            </div>
            <div class="like-box" @click="handleLikeClick(comment, index)">
              <img v-show="!comment.likeState" src="./image/like-icon.png"/>
              <img v-show="comment.likeState" src="./image/liked-icon.png"/>
              <span class="num">{{ fomatterNum(comment.likeNum, false) || '点赞' }}</span>
            </div>

          </div>

          <!-- 二级回复 -->
          <div v-if="comment.commentsLevel2.length" class="replyComments">
            <div v-for="(reply, num) in comment.commentsLevel2.slice(0, 1)" :key="reply.id" class="replyCommentList">
              <template v-if="num < 1">
                <div class="reply-comment-item">
                  <span v-lazy:background-image="reply.headImgUrl" class="commentAvatars"></span>
                  <div class="comment-content">
                    <span :style="reply.replyCrmId == '0' ? 'color:#8A9EF3' : ''" class="commentName">
                      {{ reply.userName }}
                      <span v-if="reply.isAuthor == 1" class="myComment">作者</span>
                    </span>
                    <p v-longpress="(userInfo && userInfo.crm_id == reply.crmId) ? dialogToast : ''"
                       :data-param="JSON.stringify(reply)"
                       class="commentText"
                       @click="replyComment(reply, '2')">
                      回复 <span class="commentName">{{ reply.replyUserName }}</span>: {{ reply.content }}
                    </p>
                    <p class="bottom">
                      <span class="time">
                        {{ reply.createTime }}
                        <span class="reply_btn"
                              @click="replyComment(reply, '1')">
                          回复
                        </span>
                      </span>
                    </p>
                  </div>
                  <p class="like-box" @click="handleLikeClick(reply, index, num)">
                    <img v-show="!reply.likeState" src="./image/like-icon.png"/>
                    <img v-show="reply.likeState" src="./image/liked-icon.png"/>
                    <span class="num">{{ fomatterNum(reply.likeNum, false) || '点赞' }}</span>
                  </p>
                </div>


                <div v-if="comment.commentsLevel2.length > 1" class="totalReply" @click="toReplyCom(comment)">
                  <span>查看全部{{ comment.commentsLevel2.length }}条回复</span>
                  <van-icon color="#3C638E" name="arrow"/>
                </div>
              </template>
            </div>
          </div>
        </div>
      </van-list>

      <div v-if="commentTotal > 3" class="commentMore" @click="openAllComment('down')">
        <span>展开全部{{ commentTotal }}条评论</span>
        <van-icon name="arrow"/>
      </div>

      <div class="commentMore2" @click="openAllComment('up')">
        <p>
          <span>收起全部评论</span>
          <van-icon name="arrow"/>
        </p>
      </div>
    </div>
    <!-- 评论输入框 -->
    <div v-show="isFocus" class="centerComment" @click="isBlur()">
      <div class="mask" @click="isBlur('1')" @touchmove.prevent @mousewheel.prevent></div>
      <div class="fieldWrap">
        <div class="fieldCon">
          <van-cell-group class="input-item">
            <van-field v-model="message" :autosize="{ maxHeight: 60, minHeight: 20 }"
                       :placeholder="'回复：' + replyNames" autofocus maxlength="500"
                       rows="1" type="textarea" @input="inputChange"/>
          </van-cell-group>
        </div>
        <div class="fieldTop">
          <span class="button" @click="submitAllComment()">发送</span>
        </div>
      </div>
    </div>


    <!-- 查看更多回复弹窗 -->
    <van-action-sheet v-model="show" title="全部回复">
      <!-- <van-list class="vanlist" v-model="listLoading" :finished="listFinished" :error.sync="listError" -->
      <!-- error-text="请求失败，点击重新加载" @load="getAllComment()"> -->
      <div v-for="(comment, index) in currentData" :key="index" class="commentList">
        <div class="reply-comment-item">
          <span v-lazy:background-image="comment.headImgUrl" class="commentAvatars"></span>
          <div class="comment-content">
            <span class="commentName">
              {{ comment.userName }}
              <span v-if="comment.isAuthor == 1" class="myComment">作者</span>
            </span>
            <div ref="commentList" class="commentText" @click="replyComment(comment, '1')">
              <div v-longpress="(userInfo && userInfo.crm_id == comment.crmId) ? dialogToast : ''"
                   :data-param="JSON.stringify(comment)"
                   class="con"
                   v-text="comment.content"></div>
            </div>
            <p class="bottom">
              <span class="time">
                {{ comment.createTime }}
                <span class="reply_btn"
                      @click="replyComment(comment, '1')">
                  回复
                </span>
              </span>
            </p>
          </div>
          <div class="like-box" @click="handleLikeClick(comment, index)">
            <img v-show="!comment.likeState" src="./image/like-icon.png"/>
            <img v-show="comment.likeState" src="./image/liked-icon.png"/>
            <span class="num">{{ fomatterNum(comment.likeNum, false) || '点赞' }}</span>
          </div>

        </div>
        <!-- 二级回复 -->
        <div v-if="comment.commentsLevel2.length" class="replyComments">
          <div v-for="(reply, num) in comment.commentsLevel2" :key="reply.id" class="replyCommentList">
            <div class="reply-comment-item">
              <span v-lazy:background-image="reply.headImgUrl" class="commentAvatars"></span>
              <div class="comment-content">
                  <span :style="reply.replyCrmId == '0' ? 'color:#8A9EF3' : ''" class="commentName">
                    {{ reply.userName }}
                    <span v-if="reply.isAuthor == 1" class="myComment">作者</span>
                  </span>
                <p v-longpress="(userInfo && userInfo.crm_id == reply.crmId) ? dialogToast : ''"
                   :data-param="JSON.stringify(reply)"
                   class="commentText"
                   @click="replyComment(reply, '2')">
                  回复 <span class="commentName">{{ reply.replyUserName }}</span>: {{ reply.content }}
                </p>
                <p class="bottom">
                    <span class="time">
                      {{ reply.createTime }}
                      <span class="reply_btn"
                            @click="replyComment(reply, '1')">
                        回复
                      </span>
                    </span>
                </p>
              </div>
              <p class="like-box" @click="handleLikeClick(reply, index, num)">
                <img v-show="!reply.likeState" src="./image/like-icon.png"/>
                <img v-show="reply.likeState" src="./image/liked-icon.png"/>
                <span class="num">{{ fomatterNum(reply.likeNum, false) || '点赞' }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- </van-list> -->

    </van-action-sheet>
  </div>
</template>

<style lang="less" scoped>
@import "./less/harvard.less";
@import "./less/allcomment.less";
</style>

<script>
import {Debounce, fomatterNum, getCookie, globalGoLogin,} from "@/assets/js/common.js";
import {Exposurer_commentTitle} from "@/assets/js/Exposure";

export default {
  name: "allComment",
  data() {
    return {
      hotOrNew: 0,  // 最新还是最热， 0 最新，1 最热
      listLoading: false,
      listFinished: false,
      listError: false,
      commentAllList: [],
      curVideoId: "",
      isFocus: false,
      message: "", //评论内容
      replyUserInfo: [], // 回复用户信息
      replyNames: "",
      commentParams: {
        page: 1,
        size: 25,
      },
      commentLen: 0, //评论列表当前数量
      userInfo: {},
      commentTotal: "",
      allComments: [], //初始所有评论
      upComment: [],
      commentType: "",
      oneConH: 22, //375屏幕下一行评论的高度
      firstFlag: false, //以及评论点赞开关
      secondFlag: false, //二级评论点赞开关
      isShow: true,
      arr: [],
      flag: true,
      upComShow: false, //评论箭头
      requestId: "",
      show: false,
      currentData: [],  // 当前评论
      timeOut: null,
    };
  },
  components: {},
  props: ["articalId", "isGoLogin", "module", "title", "tlabelName"],
  watch: {
    // 监听文章id触发初始化评论
    // articalId() {
    //   this.getAllComment(0);
    // },
  },
  mounted() {
    // this.getAllComment(0);
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));

    var date = Date.parse(new Date());
    var id = this.getCookie("xmh_unionid");
    this.requestId = this.$md5(date + id);

    setTimeout(() => {
      Exposurer_commentTitle.observe(".title", false, {
        that: this,
        id: this.articalId,
        type: this.tlabelName,
      });
    }, 3000);
  },
  methods: {
    fomatterNum,
    getCookie,
    //箭头控制是否打开评论
    openAllComment(tag) {
      if (tag === "down") {
        this.upComShow = true;
        $(".commentMore").css("display", "none");
        $(".commentMore2").css("display", "block");
        this.$nextTick(() => {
          this.oneConH = parseInt($(".commentText").css("line-height")) * 3;
          var that = this;
          $.each(this.$refs.commentList, function (index, item) {
            let conH = $(item).find(".con")[0].offsetHeight;
            if (conH > that.oneConH) {
              $(item).find(".openCon").css("display", "block");
            }
          });
        });
      } else {
        this.upComShow = false; //切成下
        $(".commentMore").css("display", "block");
        $(".commentMore2").css("display", "none");
      }
    },
    // 删除评论弹窗
    dialogToast(item) {
      this.$emit('sensorsFn', '删除')
      this.$dialog
          .confirm({
            message: "是否删除评论",
            confirmButtonText: "确定",
          })
          .then(() => {
            this.deleteCom(item, item.level);
          })
          .catch(() => {
          });
    },
    // 打开二级回复页
    toReplyCom(item) {
      this.$emit('sensorsFn', '查看全部回复')
      this.currentData = [item];
      this.show = true;
    },
    inputChange() {
      if (this.message.length >= 1) {
        $(".button").addClass("button2");
      } else if (this.message.length == 0) {
        $(".button").removeClass("button2");
      }
    },
    // 删除评论
    deleteCom: function (item, type) {
      this.$http.post(
          "/comment/remove",
          {},
          {
            id: item.id,
            parentId: item.parentId || "",
            itemId: this.articalId,
            module: this.module,
            crmId: this.userInfo?.crm_id
          },
          (res) => {
            if (res.code === 200) {
              // 一级评论删除之后，将弹窗关闭，并将列表数据移除
              if (item.level === 1) {
                let index = this.commentAllList.findIndex(element => element.id === item.id)
                this.commentAllList.splice(index, 1)
                this.show = false;
                this.commentTotal--;
              }
              // 二级评论删除之后，将数据在当前弹窗移除，并在列表移除
              if (item.level === 2) {
                let curParentIndex = this.commentAllList.findIndex(element => element.id === item.parentId)
                console.log(curParentIndex, 'curParentIndex')
                let data = this.show ? this.currentData[0].commentsLevel2 : this.commentAllList[curParentIndex].commentsLevel2

                let curIndex = data.findIndex(element => element.id === item.id)
                curIndex !== -1 && data.splice(curIndex, 1)
                if (this.show && data.length <= 1) {
                  this.show = false;
                }
              }
              this.$emit("changeCommentNum", false)
              this.$toast({
                duration: 2000,
                message: "删除评论成功",
                context: this,
              });

            }
          }, err => {
            console.log(err)
          }, "lucky"
      );
    },
    // 回复提交
    submitAllComment: Debounce(function () {
      if (!this.message) {
        this.$toast({
          duration: 2000,
          message: "请输入评论内容",
          context: this,
          getContainer: ".wrap"
        });
        return;
      }
      this.isFocus = false;
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let headImg = this.getCookie("xmh_headimgurl");
      let nickName = this.getCookie("xmh_nickname");
      let openid = this.getCookie("xmh_openid");
      this.$http.post(
          "/comment/save",
          {},
          {
            itemId: this.articalId,
            comments: this.message,
            crmId: this.userInfo?.crm_id,
            replyCrmId: this.replyUserInfo.crmId,
            parentId: this.replyUserInfo.level == 1 ? this.replyUserInfo.id : this.replyUserInfo.parentId,
            parentCommentId: this.replyUserInfo.id,
            level: 2,
            headImgUrl: headImg,
            userName: nickName,
            openid: openid,
            module: this.module,
          },
          (res) => {
            if (res.code == "200") {
              // 当弹窗打开时，回复评论时，添加一条数据到列表中，否则重新获取数据
              if (this.show) {
                this.currentData[0].commentsLevel2.push({
                  content: this.message,
                  createTime: res.data.createTime.split(' ')[0],
                  crmId: this.userInfo.crm_id,
                  hasChildren: false,
                  headImgUrl: headImg,
                  id: res.data.id,
                  level: 2,
                  likeNum: 0,
                  likeState: false,
                  parentId: this.replyUserInfo.level == 1 ? this.replyUserInfo.id : this.replyUserInfo.parentId,
                  replies: 0,
                  replyCrmId: this.replyUserInfo.crmId,
                  replyUserName: this.replyUserInfo.userName,
                  title: this.message,
                  userName: nickName
                })
              } else {
                this.commentParams.page = 1;
                this.getAllComment(this.hotOrNew);
              }
              this.message = "";
              $("body").css("position", "initial");
              $("body").css("overflow", "");
              $(".button").removeClass("button2");

              this.$emit("changeCommentNum", true)
              this.$toast({
                duration: 2000,
                message: "评论成功",
                context: this,
              });
            } else {
              this.$toast({
                duration: 2000,
                message: "评论失败",
                context: this,
              });
            }
          }, (err) => {
            console.log(err)
          }, 'lucky'
      );
    }, 500),
    isBlur(id) {
      if (id == "1") {
        this.isFocus = false;
        $("body").css("position", "initial");
        $("body").css("overflow", "");
      } else if (id == "2") {
      } else if (id == "3") {
      }
    },
    // 回复
    replyComment: function (item, type) {
      this.$emit('sensorsFn', '回复')
      if (this.isGoLogin) {
        globalGoLogin();
      } else {
        $("body").css("position", "absolute");
        $("body").css("overflow", "hidden");
        this.commentType = type;
        this.replyNames = item.userName;
        this.replyUserInfo = item;
        this.isFocus = true;
        this.$nextTick(() => {
          $("textarea")[1].focus();
        });
      }
    },
    handleLikeClick: Debounce(function (item, index, replyNum) {
      this.$emit('sensorsFn', '评论点赞')
      if (this.isGoLogin) {
        globalGoLogin();
      } else {
        this.$http.post("/comment/like", {},
            {
              crmId: this.userInfo?.crm_id,
              id: item.id,
              likeState: !item.likeState,
              itemId: this.articalId,
              module: this.module,
              likeNum: item.likeNum
            }, res => {
              if (res.code === 200) {
                // show为true时，表示用户打开了弹窗
                const data = this.show && this.currentData[index] || this.commentAllList[index]
                // replyNum不为null， 表示用户点击的是二级评论，
                if (replyNum != null) {
                  data.commentsLevel2[replyNum].likeState = res.data.likeStart;
                  data.commentsLevel2[replyNum].likeNum = res.data.likeNum;
                  // zcsqejdz 种草社区一级点赞
                  res.data.likeStart && this.$toast({
                    duration: 2000,
                    message: "点赞成功",
                    context: this,
                  });
                } else {
                  // 处理一级评论
                  data.likeState = res.data.likeStart;
                  data.likeNum = res.data.likeNum;
                  // zcsqyjdz 种草社区一级点赞
                  res.data.likeStart && this.$toast({
                    duration: 2000,
                    message: "点赞成功",
                    context: this,
                  });
                }
                this.commentParams.page = 1;
                this.getAllComment(this.hotOrNew)
              } else {
                this.$toast({
                  duration: 2000,
                  message: res.data.message,
                });
              }
            }, err => {
              console.log(err)
              this.$toast({
                duration: 2000,
                message: err.data.message,
              });
            }, "lucky"
        )
      }
    }),
    // 点击展开评论
    expandComment: function (event, handleType) {
      this.oneConH = parseInt($(".commentText").css("line-height")) * 3;
      if (handleType == 1) {
        //展开
        $(event.target).parents(".commentText").css("max-height", "initial");
        $(event.target)
            .parents(".commentText")
            .find(".openCon")
            .css("display", "none");
        $(event.target)
            .parents(".commentText")
            .find(".closeCon")
            .css("display", "block");
      } else {
        //收起
        $(event.target)
            .parents(".commentText")
            .css("max-height", this.oneConH + "px");
        $(event.target)
            .parents(".commentText")
            .find(".openCon")
            .css("display", "block");
        $(event.target)
            .parents(".commentText")
            .find(".closeCon")
            .css("display", "none");
      }
    },
    // 获取所有评论
    getAllComment: function (isHot, hasClear) {
      // 切换分类，如果不与上一个相同，则重置数据
      if (hasClear) {
        this.commentParams.page = 1;
      }
      // 加载更多，判断是否展开了评论，如果没有展开，则不请求接口
      if (this.commentParams.page > 1 && !this.upComShow) {
        this.listLoading = false;
        return;
      }

      this.hotOrNew = isHot
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$http.post(
          "/comment/list",
          {},
          {
            pageNum: this.commentParams.page,
            pageSize: this.commentParams.size,
            module: this.module,
            itemId: this.articalId,
            isHot: isHot,
            crmId: this.userInfo?.crm_id,
          },
          (res) => {
            if (res.code === 200) {
              const {data, total} = res.data;
              this.commentTotal = total || data.length;
              this.$emit("comTotal", this.commentTotal);
              this.commentAllList = this.commentParams.page <= 1 ? data : this.commentAllList.concat(data);
              if (this.commentParams.page * this.commentParams.size >= this.commentTotal) {
                this.listFinished = true;
              } else {
                this.commentParams.page++
              }
              this.listLoading = false;
              // 判断石佛需要重置收起展开的状态
              this.$nextTick(() => {
                hasClear && this.openAllComment("up")
              })
            }
          }, (err) => {
            this.listLoading = false;
            console.log(err, 'error-----')
          }, "lucky"
      );
    },
    // 点击打开输入评论的输入框
    isFocusFun(type) {
      if (this.isGoLogin) {
        document.activeElement.blur();
        globalGoLogin();
      } else {
        $("body").css("position", "absolute");
        $("body").css("overflow", "hidden");
        this.$emit("focusOn", true);
        this.$emit("type", type);
        // // 自动获取焦点
        this.$nextTick(() => {
          $("textarea")[0].focus();
        });
      }
    },
  },
};
</script>

